import { render, staticRenderFns } from "./product_management.vue?vue&type=template&id=0fcc3abf&scoped=true&"
import script from "./product_management.vue?vue&type=script&lang=js&"
export * from "./product_management.vue?vue&type=script&lang=js&"
import style0 from "./product_management.vue?vue&type=style&index=0&id=0fcc3abf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcc3abf",
  null
  
)

export default component.exports